module.exports = __webpack_public_path__ + "img/ambassador.efdaaf46.svg";